<template>
    <component
        :is="tag"
        v-bind="$attrs"
        :href="tag === 'a' ? href : null"
        :target="tag === 'a' ? target : null"
        :rel="tag === 'a' ? rel : null"
        :type="tag === 'button' ? 'button' : null"
        :class="btnClass"
        :disabled="disabled"
        @click="$emit('click', $event)"
    >
        <slot />
    </component>
</template>

<script>
export default {
    name: "Buttons",
    inheritAttrs: false,
    emits: ["click"],
    props: {
        tag: { type: String, default: "button" }, // button / a
        href: { type: String, default: "#none" },
        target: { type: String, default: null },
        rel: { type: String, default: null },
        btnClass: { type: String, default: "btn_fill" },
        disabled: { type: Boolean, default: false },

        // tag: { type: String, default: "button" },
        // href: { type: String, default: "#none" },
        // btnClass: {
        //     type: [String, Array, Object],
        //     default: () => "btn_fill"
        // },
        // disabled: { type: Boolean, default: false }
    },
};
</script>
